// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultCursor[data-v-54ad2908] {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/LeasingCarAside.vue","webpack://./LeasingCarAside.vue"],"names":[],"mappings":"AACA;EACE,eAAA;ACAF","sourcesContent":["\r\n.defaultCursor {\r\n  cursor: default;\r\n}\r\n",".defaultCursor {\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
